// Hooks barrel exports
export { useI18nContext } from '../providers/I18nProvider';
export { useColorScheme } from './useColorScheme';
export { useDeviceId } from './useDeviceId';
export { useTheme, type UseThemeReturn } from './useTheme';
export { useThemeColor } from './useThemeColor';
export { useTranslation } from './useTranslation';
export { useUIColors } from './useUIColors';
export { useIsAdhaJourney, getIsAdhaJourney } from './useIsAdhaJourney';
export { useSalesAgentContact, type SalesAgentContact } from './useSalesAgentContact';
export {
  useAutoCloseOnVisible,
  SUCCESS_DIALOG_AUTO_CLOSE_MS,
} from './useAutoCloseOnVisible';
export {
  useReservationActions,
  type ReservationActionResult,
} from './useReservationActions';
export { useLoginConfig, type LoginConfigState } from './useLoginConfig';
export { useEmiratesIdOtpResendSeconds } from './useEmiratesIdOtpResendSeconds';
export { useContentfulRevision } from './useContentfulRevision';
export { useWebViewport, type WebViewportState } from './useWebViewport';
export { useSingleTapAction } from './useSingleTapAction';
export { useFocusVisible } from './useFocusVisible';

